import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { RecipientModel } from 'src/app/core/models/recipient.model';
import { RecipientsService } from 'src/app/core/services/recipients.service';

@Component({
  selector: 'app-select-recipients',
  templateUrl: './select-recipients.component.html',
  styleUrls: ['./select-recipients.component.scss']
})
export class SelectRecipientsComponent implements OnInit {
  @Input() recipients: RecipientModel[] = [];

  search = new UntypedFormControl('');
  filterRecipients: RecipientModel[];
  showRecipients: boolean = false;
  idSelected: any = '';
  noRecipients: boolean = false;
  isRecipient: boolean = false;
  addRecipient: boolean = false;
  loading: boolean = false;
  @Output() RecipientDeleted: EventEmitter<any> = new EventEmitter();
  @Output() RecipientSelected: EventEmitter<any> = new EventEmitter();
  @Output() ClosedRecipientList: EventEmitter<any> = new EventEmitter();
  @Output() sendRecipient: EventEmitter<RecipientModel> = new EventEmitter();
  selectedRecipient: RecipientModel = undefined;

  constructor(private translateService: TranslateService, private recipientsService: RecipientsService) {
    this.filterRecipients = this.recipients;
  }

  async ngOnInit() {
    this.loading = true;
    this.filterRecipients = this.recipients;
    this.loading = false;
    this.search.valueChanges.pipe(debounceTime(150)).subscribe((value) => this.handleSearch(value));
  }

  handleSearch(value: string) {
    this.filterRecipients = this.recipients.filter(
      (user) =>
        user.nombre.toUpperCase().includes(value.toUpperCase()) ||
        (user.alias && user.alias.toUpperCase().includes(value.toUpperCase())) ||
        (user.cvuCbu && user.cvuCbu.toUpperCase().includes(value.toUpperCase()))
    );
    !this.filterRecipients.length ? (this.noRecipients = true) : (this.noRecipients = false);
  }

  selectRecipient(recipient: RecipientModel) {
    this.selectedRecipient = recipient;
  }

  confirmRecipient(recipient) {
    this.selectRecipient(recipient);
    this.RecipientSelected.emit(recipient);
  }

  async deleteRecipient(recipient: RecipientModel) {
    await this.recipientsService.deleteRecipient(recipient);
    this.borrarElemento(recipient);
    this.resetSelectedRecipient();
    this.confirmRecipient(this.selectedRecipient);
    this.selectedRecipient = null;
  }

  resetSelectedRecipient() {
    this.selectedRecipient = { id: null, tipoPersona: '', nombre: null, cvuCbu: '', alias: '' };
  }

  borrarElemento(recipient) {
    let index = this.recipients.map((r) => r.id).indexOf(recipient.id);
    this.recipients.splice(index, 1);
  }

  closeList() {
    this.ClosedRecipientList.emit();
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }

  tieneDestinatarios(): boolean {
    return this.recipients.length !== 0;
  }

  agregarDestinatario(): void {
    this.addRecipient = true;
  }
}
